import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link } from 'react-router-dom';
import './TextEffectSection.css';

gsap.registerPlugin(ScrollTrigger);

const TextEffectSection = () => {

  const headRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (headRef.current) observer.observe(headRef.current);
    return () => observer.disconnect();
  }, []);

  const splitWords = (text) => {
    return text.split(' ').map((word, index) => {
      return (
        <span
          key={index}
          className="word-animate"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          {word}&nbsp;
        </span>
      );
    });
  };

  const containerRef = useRef(null);

  useEffect(() => {
    // Only run if the elements exist
    const textElements = gsap.utils.toArray('.text-effect');

    // Make sure each element properly scopes its own animation
    textElements.forEach(text => {
      gsap.to(text, {
        backgroundSize: '100%',
        ease: 'none',
        scrollTrigger: {
          trigger: text,
          start: 'center 80%',
          end: 'center 20%',
          scrub: true,
        },
      });
    });

    return () => {
      // Clean up ScrollTriggers created in this component
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, []);

  return (
    <div className="text-effect-container" ref={containerRef}>
      <h1 className="text-effect">NEXAWAVE <span>INNOVATION</span></h1>
      <h1 className="text-effect">PREMIUM <span>HARDWARE</span></h1>
      <h1 className="text-effect">ULTIMATE <span>PERFORMANCE</span></h1>
      <h1 className="text-effect">EXPLORE MORE <span><Link to="/">ALL PRODUCTS</Link></span></h1>
      <h1 className="text-effect">READY TO BUY? <span><Link to="/cart">VIEW CART</Link></span></h1>
    </div>
  );
};

export default TextEffectSection;
